import axios from './request'
/**
 * 查询城市是否支持筛选
 * @param {Object} params 查询参数
 * @param {Number} params.cityId 城市ID
 * @param {String} params.cds 筛选项id
 */
export function searchfilteritem(params) {
  return axios.post(process.env.VUE_APP_M_TUJIA_HOST + '/feapi/bingo/h5/promotion/filter/searchfilteritem', {
  // return axios.post('https://pwa.tujia.com/feapi/bingo/h5/promotion/filter/searchfilteritem', {
    ...params
  })
}
